import styles from './FilterToggle.module.scss';

interface Props {
  children: React.ReactNode;
  activeFilter: string[];
  handleClick: (activeFilter: string[]) => void;
  filterValues: string[];
}

const FilterToggle = ({ children, activeFilter, filterValues, handleClick }: Props): JSX.Element => {
  return (
    <div className={styles.container}>
      <button
        onClick={() => handleClick(filterValues)}
        className={
          filterValues.length === activeFilter.length &&
          filterValues.every((value, index) => value === activeFilter[index])
            ? styles.active
            : ''
        }
      >
        {children}
      </button>
    </div>
  );
};

export default FilterToggle;
